import type { FormikProps } from 'formik'
import { useFormik } from 'formik'

import { MIN_MESSAGE_LENGTH } from 'features/bug-report/constants'

export type BugReportFormValues = {
  message: string
}

type Args = {
  onSubmit: (
    message: string,
    helpers: { resetForm: () => void },
  ) => Promise<void>
}

export type UseBugReportFormReturn = {
  formik: FormikProps<BugReportFormValues>
  errorMessage: string | null
}

export function useBugReportForm({ onSubmit }: Args): UseBugReportFormReturn {
  const formik = useFormik<BugReportFormValues>({
    initialValues: { message: '' },
    validateOnChange: false,
    validateOnBlur: false,
    validate: (values) => {
      const errors: Partial<Record<keyof BugReportFormValues, string>> = {}
      if (
        !values.message ||
        values.message.trim().length < MIN_MESSAGE_LENGTH
      ) {
        errors.message = `Please describe the bug (at least ${MIN_MESSAGE_LENGTH} characters).`
      }
      return errors
    },
    onSubmit: async (values, { resetForm }) => {
      await onSubmit(values.message, { resetForm })
    },
  })

  const errorMessage =
    formik.submitCount > 0 && formik.errors.message
      ? formik.errors.message
      : null

  return { formik, errorMessage }
}
